module.exports = __webpack_public_path__ + "static/carbonel-d651995afdaf7c8829b989a2d346d2ec.jpg";